import "./../../public/icon-font/style.css";
import { LOCALE } from "@/enums/locale";
import { APP_COLORS } from "@/config/app-colors";

import Vue from "vue";
import Vuetify from "vuetify/lib";
import pl from "vuetify/es5/locale/pl";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pl },
    current: LOCALE.PL
  },
  icons: {
    iconfont: "mdi",
    values: {
      checkboxOff: "icon-checkbox-off",
      checkboxOn: "icon-checkbox-on",
      radioOff: "icon-radio-off",
      radioOn: "icon-radio-on"
    }
  },
  theme: {
    themes: {
      light: {
        blueFb: APP_COLORS.BLUE_FB,
        primary: APP_COLORS.PRIMARY,
        secondary: APP_COLORS.SECONDARY,
        darkGreen: APP_COLORS.DARK_GREEN,
        success: APP_COLORS.SUCCESS,
        accent: APP_COLORS.ACCENT,
        info: APP_COLORS.INFO,
        error: APP_COLORS.ERROR,
        "red-1": APP_COLORS.RED_1,
        "green-1": APP_COLORS.GREEN_1,
        "orange-1": APP_COLORS.ORANGE_1,
        teal: APP_COLORS.TEAL,
        light: APP_COLORS.LIGHT,
        pink: APP_COLORS.PINK,
        text: APP_COLORS.TEXT,
        "text-muted": APP_COLORS.TEXT_MUTED,
        "red-2": APP_COLORS.RED_2,
        "gray-2": APP_COLORS.GRAY_2
      },
      dark: {
        blueFb: APP_COLORS.BLUE_FB,
        primary: APP_COLORS.PRIMARY,
        secondary: APP_COLORS.SECONDARY,
        darkGreen: APP_COLORS.DARK_GREEN,
        success: APP_COLORS.SUCCESS,
        accent: APP_COLORS.ACCENT,
        info: APP_COLORS.INFO,
        error: APP_COLORS.ERROR,
        "red-1": APP_COLORS.RED_1,
        "green-1": APP_COLORS.GREEN_1,
        "orange-1": APP_COLORS.ORANGE_1,
        teal: APP_COLORS.TEAL,
        light: APP_COLORS.LIGHT,
        pink: APP_COLORS.PINK,
        text: APP_COLORS.TEXT,
        "text-muted": APP_COLORS.TEXT_MUTED,
        "red-2": APP_COLORS.RED_2,
        "gray-2": APP_COLORS.GRAY_2
      }
    }
  }
});
